var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #293b7c;\n        fill-rule: evenodd;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fefefe;\n        stroke: #3c3c3b;\n        stroke-miterlimit: 10;\n        stroke-width: .2px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.5,
    cy: 15.5,
    r: 14.7,
    transform: "translate(-.5 30.4) rotate(-87.9)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.5,3.8v7.5H1.4c-.4,1.3-.6,2.7-.6,4.2s.2,2.8.6,4.1h5.2v7.5c2.3,1.8,5.2,2.9,8.3,3v-10.6h14.8c.4-1.3.6-2.7.6-4.1s-.2-2.8-.6-4.2h-14.8V.8c-3.1.1-6,1.2-8.3,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFin);
export default __webpack_public_path__ + "static/media/fin.721647a88845a8ff25a5b91e7cad462b.svg";
export { ForwardRef as ReactComponent };